import * as echarts from "echarts";
import VueEcharts from "vue-echarts";

export default defineNuxtPlugin((nuxtApp) => {
  // client-only: vue-echarts touches `document` during init
  nuxtApp.vueApp.component("VChart", VueEcharts);
  nuxtApp.provide("echarts", echarts);
});

